// extracted by mini-css-extract-plugin
module.exports = {"departments":"df-z","departmentHeading":"ef-z","departmentSection":"ff-z","departmentName":"gf-z","departmentLink":"hf-z","expandIcon":"if-z"};